import * as React from "react";
import type { SVGProps } from "react";
const SvgStarWithSparkles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9 5c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1M5.995 7H6h-.01zm.705-.29a.98.98 0 0 1-.705.29 1.02 1.02 0 0 1-.705-.29l-2-2A.996.996 0 1 1 4.7 3.3l2 2c.39.39.39 1.02 0 1.41M18.665 22h.005-.01zm.575-.19a1.03 1.03 0 0 1-.575.19c-.148 0-.307-.04-.445-.11L14 19.78l-4.22 2.11a1 1 0 0 1-1.44-1.03l.71-4.95-2.76-2.76a1.02 1.02 0 0 1-.25-1.01c.11-.36.42-.62.79-.68l4.16-.69 2.11-4.21c.34-.68 1.45-.68 1.79 0L17 10.77l4.16.69a.992.992 0 0 1 .54 1.69l-2.76 2.76.71 4.95c.05.37-.1.74-.41.95m-4.79-4.03c-.14-.07-.3-.11-.45-.11-.16 0-.31.04-.45.11l-2.96 1.48.51-3.55a.99.99 0 0 0-.28-.85l-1.74-1.74 2.75-.46a.99.99 0 0 0 .73-.54L14 9.24l1.44 2.88c.14.29.41.49.73.54l2.75.46-1.74 1.74c-.22.22-.32.54-.28.85l.51 3.55zM3 10h1c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1s.45 1 1 1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStarWithSparkles;
